import { render, staticRenderFns } from "./StActivityList.vue?vue&type=template&id=5224cad6&scoped=true"
import script from "./StActivityList.vue?vue&type=script&lang=js"
export * from "./StActivityList.vue?vue&type=script&lang=js"
import style0 from "@/assets/sass/pages/activities/activities.scss?vue&type=style&index=0&id=5224cad6&prod&scoped=true&lang=scss&external"
import style1 from "./StActivityList.vue?vue&type=style&index=1&id=5224cad6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5224cad6",
  null
  
)

export default component.exports